import { Component, Input, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
  selector: 'app-form-text-input',
  standalone: true,
  imports: [CommonModule, FormsModule],
  template: `
    <div class="form-section">
      <label [attr.for]="id" [class.required-field]="required">{{ label }}</label>
      <div *ngIf="readonly" class="readonly-value">
        {{ value || '-' }}
      </div>
      <input
        *ngIf="!readonly"
        type="text"
        [id]="id"
        [name]="name"
        [placeholder]="placeholder"
        [ngModel]="value"
        (ngModelChange)="onChange($event)"
        (blur)="onTouched()"
        class="form-input"
      />
    </div>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormTextInputComponent),
      multi: true,
    },
  ],
  styleUrls: ['total-component.scss']
})
export class FormTextInputComponent implements ControlValueAccessor {
  @Input() label: string = 'Label';
  @Input() id: string = 'text-input';
  @Input() name: string = 'text-input';
  @Input() placeholder: string = '';
  @Input() required: boolean = false;
  @Input() readonly: boolean = false; // 新增：只讀模式

  value: string = '';

  onChange = (value: any) => {};
  onTouched = () => {};

  // ControlValueAccessor 實作
  writeValue(value: any): void {
    this.value = value;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    // 如有需要，可加上 disabled 邏輯
  }
}
